import styled from 'styled-components';

export default styled.time`
  font-size: 14px;
  color: var(--text-color-light-gray);
  maring: 0;
`;
